<template>
  <v-form ref="form" autocomplete="off" :key="renderKey" class="transparent">
    <v-expansion-panels
      :value="allPanelExpanded()"
      :disabled="
        !formFilterScreen({
          screen,
          interactive: true,
          dynamic: formFilterDynamic,
        })
      "
      :flat="true"
    >
      <v-expansion-panel
        header-padding="0px 0px"
        content-padding="0px 0px"
        @change="panelClick"
      >
        <v-expansion-panel-header
          v-if="
            /*
            formFilterScreen({
              screen,
              interacive: true,
              dynamic: formFilterDynamic,
            })
            */
            false //allPanelExpanded() == 0
          "
          expand-icon="mdi-filter"
          disable-icon-rotate
        >
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table dense class="form-table">
            <template v-slot:default>
              <v-container fluid>
                <v-row
                  v-for="(start, startIdx) in fieldsStartingRow(true)"
                  :key="startIdx"
                  dense
                  no-gutters
                >
                  <v-col
                    v-for="(field, idx) in fieldsOnRow(startIdx, start.divider)"
                    :key="idx"
                    :cols="
                      (12 * maxFieldCols()) /
                      fieldColSpan(startIdx, start.divider)
                    "
                    class="col-form-field"
                  >
                    <div v-if="start.divider">
                      <v-card
                        elevation="2"
                        class="mx-auto pa-4"
                        :color="tertiaryColor(generalExApplicationEx)"
                      >
                        {{ start.title }}
                      </v-card>
                    </div>

                    <div v-else>
                      <FormField
                        :dictionary="
                          findDictionary(screen, field.formField.dictionaryName)
                        "
                        :id="getFieldId(field.oriIndex)"
                        :index="field.oriIndex"
                        :name="field.formField.fieldName"
                        :permission="menu.permission"
                        :method="method"
                        :access="field.formField.access"
                        :customStyle="getField(field.oriIndex).customStyle"
                        :label="
                          translatedConfig(
                            generalExApplicationEx,
                            customLanguage,
                            field.formField,
                            'caption'
                          )
                        "
                        :value="getField(field.oriIndex).value"
                        :prefix="field.formField.prefix"
                        :suffix="field.formField.suffix"
                        :items="
                          translatedItems(
                            generalExApplicationEx,
                            customLanguage,
                            findCatalogExList(
                              screen,
                              field.formField.dictionaryName,
                              buildInputData(field.formField.inputFields)
                            ),
                            'itemId'
                          )
                        "
                        :keyPos="field.formField.keyPos"
                        :align="'left'"
                        :rules="getField(field.oriIndex).rules"
                        :errorCount="getField(field.oriIndex).errorCount"
                        :pattern="
                          findDictionary(screen, field.formField.dictionaryName)
                            .pattern
                        "
                        :mask="
                          findDictionary(screen, field.formField.dictionaryName)
                            .mask
                        "
                        :generalExApplicationEx="generalExApplicationEx"
                        :uploaded="getField(field.oriIndex).uploaded"
                        :selected="getField(field.oriIndex).selected"
                        :progress="getField(field.oriIndex).progress"
                        :loading="getLoading(field)"
                        :foreignKey="field.formField.foreignKey"
                        :browseHelp="field.formField.browseHelp"
                        :inputFields="field.formField.inputFields"
                        :ref="getFieldId(field.oriIndex) + 'Ref'"
                        :length="
                          field.formField.length
                            ? field.formField.length
                            : findDictionary(
                                screen,
                                field.formField.dictionaryName
                              ).length
                        "
                        :secLength="
                          field.formField.secLength
                            ? field.formField.secLength
                            : findDictionary(
                                screen,
                                field.formField.dictionaryName
                              ).secLength
                        "
                        :customLanguage="customLanguage"
                        :upperLower="field.formField.upperLower"
                        :queryFlag="false"
                        :hint="
                          translatedConfig(
                            generalExApplicationEx,
                            customLanguage,
                            field.formField,
                            'hint'
                          )
                        "
                        :link="
                          translatedConfig(
                            generalExApplicationEx,
                            customLanguage,
                            field.formField,
                            'link'
                          )
                        "
                        :object="field.formField"
                        :environment="environment"
                        :screen="screen"
                        :formData="formData"
                        :session="session"
                        :url="getField(field.oriIndex).url"
                        :fillTo="
                          findDictionary(screen, field.formField.dictionaryName)
                            .fillTo
                        "
                        :filler="
                          findDictionary(screen, field.formField.dictionaryName)
                            .filler
                        "
                        :catalogingList="catalogingList"
                        @handle-change="handleChange"
                        @handle-key-down="handleKeyDown"
                        @handle-browse-help="handleBrowseHelp"
                        @handle-foreign-key="handleForeignKey"
                        @set-loading="setLoading"
                        @update-notification="updateNotification"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-simple-table>

          <div>
            <ButtonField
              v-if="showSubmit()"
              :title="
                translatedConfig(
                  generalExApplicationEx,
                  customLanguage,
                  screen.transaction,
                  'submitTitle'
                )
              "
              :loading="loading || submitting"
              :disabled="disableSubmit()"
              :screen="screen"
              :filter="formFilterScreen({ screen, dynamic: formFilterDynamic })"
              :upload="formUploadScreen(screen)"
              @button-click="submitForm"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-form>
</template>

<script>
import ButtonField from "./fields/ButtonField";
import FormField from "./fields/FormField";
//import Actions from "./Actions";
export default {
  name: "Form",
  props: [
    "transactionName",
    "generalExApplicationEx",
    "screen",
    "formData",
    "loadedTransaction",
    "loading",
    "submitting",
    "method",
    "menu",
    "changeHappened",
    "embed",
    "renderKey",
    "filter",
    "customLanguage",
    "formFilterDynamic",
    "oneFieldFilter",
    "environment",
    "session",
    "underProcessing",
    "secondaryUnderProcessing",
    "dictionaryingList",
    "catalogingList",
  ],
  display: "Form",
  components: {
    FormField,
    ButtonField,
    //Actions,
  },
  data() {
    return {
      formValidation: false,
      formSubmitted: false,
      panelExpanded: false,
    };
  },
  methods: {
    sizedFormFields(dividers) {
      let result = [];
      let line = [];
      const count = this.screen.formFieldsEx.length;
      const max = this.betterMaxfields();

      this.screen.formFieldsEx.forEach((f, i) => {
        const last = i == count - 1;
        const next = i < count ? this.screen.formFieldsEx[i + 1] : null;
        const nextStart = next ? next.startRow : false;
        const end = f.formField.endRow;

        let sizeBreak = false;
        if (max) {
          if (line.length + 2 > max) {
            sizeBreak = true;
          }
        }

        const lineBreak = end || nextStart || last || sizeBreak;

        if (
          dividers &&
          f.formField.dividerText &&
          f.formField.access != "hidden"
        ) {
          const divider = {
            oriIndex: i,
            divider: true,
            title: this.translatedConfig(
              this.generalExApplicationEx,
              this.customLanguage,
              f.formField,
              "dividerText"
            ),
          };
          result.push([divider]);
        }

        let field = f;
        field.oriIndex = i;
        line.push(field);
        if (lineBreak) {
          result.push(line);
          line = [];
        }
      });

      return result;
    },

    lastField(getIndex) {
      return getIndex === this.screen.formFieldsEx.length - 1;
    },

    firstField(getIndex) {
      return getIndex === 0;
    },

    firstRowField(getIndex) {
      const thisStart = this.screen.formFieldsEx[getIndex].formField.startRow;
      const prevEnd =
        !this.firstField(getIndex) &&
        this.screen.formFieldsEx[getIndex - 1].formField.endRow;
      let result = getIndex == 0 || thisStart || prevEnd;
      return result;
    },

    fieldsStartingRow(dividers) {
      let fieldsEx = [];

      this.sizedFormFields(dividers).forEach((line) => {
        fieldsEx.push(line[0]);
      });

      return fieldsEx;
    },

    fieldsOnRow(lineIndex, divider) {
      let fieldsEx = [];
      if (divider) {
        fieldsEx.push({});
      } else {
        const line = this.sizedFormFields(true)[lineIndex];
        fieldsEx = line;
      }

      return fieldsEx;
    },

    maxFieldCols() {
      let result = 1;
      const all = this.sizedFormFields(false);
      all.forEach((line) => {
        if (line.length > result) {
          result = line.length;
        }
      });
      result = this.adjustMaxFields(result);
      return result;
    },

    fieldColSpan(getRowIndex, divider) {
      if (divider) {
        return this.maxFieldCols();
      } else {
        const fields = this.fieldsOnRow(getRowIndex);
        const rowCols = fields.length;
        const maxCols = this.maxFieldCols();
        const result = maxCols / rowCols;
        return result.toString();
      }
    },

    getField(getId) {
      return this.formData[this.getFieldId(getId)];
    },

    getFieldName(getId) {
      return this.getField(getId).name;
    },

    getFieldValue(getId) {
      return this.getField(getId).value;
    },

    getFieldError(getId) {
      return this.getField(getId).error;
    },

    getFieldErrorMessages(getId) {
      return this.getField(getId).errorMessages;
    },

    getFieldValueByName(getField) {
      let result = null;
      this.screen.formFieldsEx.forEach((formFieldEx, i) => {
        if (formFieldEx.formField.fieldName == getField) {
          result = this.getFieldValue(i);
        }
      });
      return result;
    },

    handleChange(data) {
      this.$emit("handle-change", data);
    },

    validateField(formFieldEx) {
      let error = false;
      let errorMessages = [];
      if (formFieldEx.formField.access == "required") {
        let value = this.formData[this.getFieldId(formFieldEx.oriIndex)].value;
        value = value ? value : "";
        if (value == "") {
          error = true;
          errorMessages.push("Required");
        }
      }
      return { error, errorMessages };
    },

    setFormValidation() {
      this.formValidation = this.$refs.form
        ? this.$refs.form.validate()
        : false;
      return this.formValidation;
    },

    submitForm() {
      if (this.setFormValidation()) {
        this.$emit("submit-form");
      }
      this.formSubmitted = true;
    },

    handleKeyDown(key, id) {
      if (key == "Enter" && id) {
        this.submitForm();
      }
    },

    showSubmit() {
      const general =
        this.screen.transaction.submitTitle !== "" && this.loadedTransaction;
      const form = this.formScreen(this.screen);
      const query = this.formFilterScreen({
        screen: this.screen,
        interactive: true,
        dynamic: false,
      });
      const calendar = this.calendarScreen(this.screen);
      return general && (form || query || calendar);
    },

    disableSubmit() {
      let result = false;
      if (!this.formAllReadOnly(this.screen)) {
        result = true;
      } else if (this.secondaryUnderProcessing) {
        result = true;
      } else {
        result = !this.changeHappened;
      }
      return result;
    },

    handleBrowseHelp(data) {
      this.$emit("handle-browse-help", data);
    },

    handleForeignKey(data) {
      this.$emit("handle-foreign-key", data);
    },

    setFieldValue(id, value, autoSource) {
      try {
        const fieldRef = id + "Ref";
        this.$refs[fieldRef][0].setValue(value, autoSource);
      } catch (error) {
        console.log(error);
      }
    },

    reRender() {
      this.$forceUpdate();
      this.$mount();
    },

    setLoading(status) {
      this.$emit("set-loading", status);
    },

    panelClick() {
      this.panelExpanded = !this.panelExpanded;
    },

    callAction(params) {
      this.$emit("call-action", params);
    },

    allPanelExpanded() {
      const filterScreen = this.formFilterScreen({
        screen: this.screen,
        interactive: true,
        dynamic: this.formFilterDynamic,
      });

      const requiredFilter = this.formFirstFilterScreen(this.screen);

      return filterScreen && !requiredFilter
        ? this.panelExpanded || this.oneFieldFilter
          ? 0
          : null
        : 0;
    },

    getLoading(ffe) {
      const field = this.getField(ffe.oriIndex);
      const dictionary = this.findDictionary(
        this.screen,
        ffe.formField.dictionaryName
      );
      const fLoading = field.loading;
      const dLoading = this.dictionaryingList
        ? this.dictionaryingList.find(
            (d) => (d.dictionaryName == dictionary.name)
          ) != null
        : false;
      const cLoading = this.catalogingList
        ? this.catalogingList.find(
            (c) => (c.dictionaryName == dictionary.name)
          ) != null
        : false;
      return fLoading || dLoading || cLoading;
    },

    updateNotification(data) {
      this.$emit("update-notification", data);
    },
  },

  updated() {},
};
</script>

<style scoped>
.col-form-field {
  padding-left: 10px;
  padding-right: 10px;
}
</style>
